import { Outlet } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import PopUp from '../../components/PopUp';

function DefaultLayout() {
  
    return (
          <div className='default-layout'>
            <Navigation/>
            <Outlet />
            <Footer/>
          </div>
      );
    }
    
    export default DefaultLayout;